"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var ClickBusting_1 = require("../config/ClickBusting");
var TabStyles_1 = require("../styles/TabStyles");
var DomUtil_1 = require("../utils/DomUtil");
var InteractiveDom_1 = require("../utils/InteractiveDom");
var DomWidgets_1 = require("./DomWidgets");
var DynamicThemeComponent_1 = require("./DynamicThemeComponent");
var InputLabelWidget_1 = require("./InputLabelWidget");
var RadioButtonWidget_1 = require("./RadioButtonWidget");
var LabelStyleName = TypeStyle.style({
    display: 'flex',
    minHeight: TabStyles_1.TabStyles.Sizing.ListRowHeight,
});
var TextStyleName = TypeStyle.style({
    boxSizing: 'border-box',
    lineHeight: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
});
var RadioButtonWithLabelWidget = /** @class */ (function (_super) {
    tslib_1.__extends(RadioButtonWithLabelWidget, _super);
    function RadioButtonWithLabelWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.labelRef = React.createRef();
        _this.handleMouseEnter = function () {
            var labelElem = _this.labelRef.current;
            _this.setState({ title: DomUtil_1.isElementOverflownX(labelElem) ? labelElem.textContent : undefined });
        };
        return _this;
    }
    RadioButtonWithLabelWidget.prototype.render = function () {
        var _a = this.props, containerStyle = _a.containerStyle, label = _a.label, radioButtonProps = tslib_1.__rest(_a, ["containerStyle", "label"]);
        return (React.createElement(DomWidgets_1.Block, { className: ClickBusting_1.ClickBustingConfig.suppressionClassName, onMouseEnter: this.handleMouseEnter, title: this.state.title },
            React.createElement(InputLabelWidget_1.InputLabelWidget, { className: LabelStyleName, disabled: radioButtonProps.disabled, style: containerStyle, testId: radioButtonProps.testId },
                React.createElement(RadioButtonWidget_1.RadioButtonWidget, tslib_1.__assign({}, radioButtonProps, { hover: this.state.hover })),
                React.createElement("div", { className: TextStyleName, ref: this.labelRef }, label))));
    };
    RadioButtonWithLabelWidget = tslib_1.__decorate([
        InteractiveDom_1.InteractiveDomHoCDecorator
    ], RadioButtonWithLabelWidget);
    return RadioButtonWithLabelWidget;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.RadioButtonWithLabelWidget = RadioButtonWithLabelWidget;
//# sourceMappingURL=RadioButtonWithLabelWidget.js.map